import * as Geocoding from 'esri-leaflet-geocoder';
import L from 'leaflet';

// we make geocoding work through those intermediate functions
// to let us later on switch quickly to other types of geocoding by making
// geocoding by other providers with the same response as esri geocoding.

function isJsonString(str) {
  try { JSON.parse(str); } catch (e) { return false; }
  return true;
}

export function getJurisdictionBoundaries() {
  let boundaries = root.app.dbConfig.MAP_BASE_BOUNDARIES;
  if (!boundaries) return;
  let bnds = JSON.parse(boundaries);
  return L.latLngBounds(bnds);
}

export function getJurisdictionBoundariesCenterLatLng() {
  let boundaries = getJurisdictionBoundaries();
  if (boundaries) return boundaries.getCenter();
  return null;
}

export function getARCGISGeocodeToken() {
  return root.app.dbConfig.GIS_ARCGIS_ONLINE_GEOCODING_TOKEN;
}

export function checkARCGISToken() {
  if ((getARCGISGeocodeToken() ?? '') == '') {
    return 'Please specify ArcGIS token in "GIS_ARCGIS_ONLINE_GEOCODING_TOKEN" setting. Feature disabled.';
  }
  return null;
}

export function getARCGISGeocodingService() {
  return root.app.dbConfig.GIS_ARCGIS_CUSTOMER_GEOCODING_SERVICE;
}

export function msGeocode(address, cb) {
  const center = getJurisdictionBoundariesCenterLatLng();

  // https://developers.arcgis.com/esri-leaflet/api-reference/tasks/geocode/
  if (center) {
    Geocoding.geocode({ apikey: getARCGISGeocodeToken() }).text(address).nearby(center, 20000).run((err, results, response) => {
      // console.log('geo_nearby:', results, center);
      cb(err, results, response);
    });
  }
  else {
    Geocoding.geocode().text(address).run((err, results, response) => {
      // console.log('geo no bounds:', results);
      cb(err, results, response);
    });
  }
}

export function msGeocodeSync(address) {
  if (!getARCGISGeocodeToken()) return Promise.resolve({ results: [] });
  const center = getJurisdictionBoundariesCenterLatLng();

  // https://developers.arcgis.com/esri-leaflet/api-reference/tasks/geocode/
  if (center) {
    return new Promise(resolve => {
      Geocoding.geocode({ apikey: getARCGISGeocodeToken() }).text(address).nearby(center, 20000).run((err, results, response) => {
        resolve(results);
      });
    });
  }

  return new Promise(resolve => {
    Geocoding.geocode().text(address).run((err, results, response) => {
      resolve(results);
    });
  });
}

/*
result.address object properties

AddNum: "28"
Addr_type: "POI"
Address: "28 Hammond"
Block: ""
City: "Irvine"
CountryCode: "USA"
District: ""
LongLabel: "Burke Investment Company, 28 Hammond, Irvine, CA, 92618, USA"
Match_addr: "Burke Investment Company"
MetroArea: ""
Neighborhood: ""
PlaceName: "Burke Investment Company"
Postal: "92618"
PostalExt: ""
Region: "California"
Sector: ""
ShortLabel: "Burke Investment Company"
Subregion: "Orange County"
Territory: ""
Type: "Other Shops and Service"
*/

export function msReverseGeocode(latlng, cb) {
  if (checkARCGISToken()) return cb(checkARCGISToken());
  Geocoding.reverseGeocode({ apikey: getARCGISGeocodeToken() }).latlng(latlng).run((error, result, response) => {
    // fill shortState
    if (result.address.Region) {
      Object.keys(StateMapping).forEach(k => {
        let v = StateMapping[k];
        if (v.toLowerCase() == (result.address.Region + '').toLowerCase()) {
          result.address.RegionShort = k;
        }
      });
    }

    // fill street
    if (result.address.Address) {
      let ind = result.address.AddNum?.length;
      ind = ind ? ind + 1 : 0;
      result.address.Street = result.address.Address.substr(ind);
    }

    cb(error, result, response);
  });
}


const StateMapping = {
  'AA':	'Armed Forces (the) Americas',
  'AB':	'Alberta',
  'AE':	'Armed Forces Europe',
  'AK':	'Alaska',
  'AL':	'Alabama',
  'AP':	'Armed Forces Pacific',
  'AR':	'Arkansas',
  'AS':	'American Samoa',
  'AZ':	'Arizona',
  'BC':	'British Columbia',
  'CA':	'California',
  'CD':	'Canada',
  'CO':	'Colorado',
  'CT':	'Connecticut',
  'DC':	'Dist. Of Columbia',
  'DE':	'Delaware',
  'FF':	'Foreign Countries',
  'FL':	'Florida',
  'GA':	'Georgia',
  'GU':	'Guam',
  'HI':	'Hawaii',
  'IA':	'Iowa',
  'ID':	'Idaho',
  'IL':	'Illinois',
  'IN':	'Indiana',
  'KS':	'Kansas',
  'KY':	'Kentucky',
  'LA':	'Louisiana',
  'MA':	'Massachusetts',
  'MB':	'Manitoba',
  'MD':	'Maryland',
  'ME':	'Maine',
  'MI':	'Michigan',
  'MN':	'Minnesota',
  'MO':	'Missouri',
  'MS':	'Mississippi',
  'MT':	'Montana',
  'MX':	'Mexico',
  'NB':	'New Brunswick',
  'NC':	'North Carolina',
  'ND':	'North Dakota',
  'NE':	'Nebraska',
  'NH':	'New Hampshire',
  'NJ':	'New Jersey',
  'NL':	'Newfoundland and Labrador',
  'NM':	'New Mexico',
  'NS':	'Nova Scotia',
  'NT':	'Northwest Territories',
  'NU':	'Nunavut',
  'NV':	'Nevada',
  'NY':	'New York',
  'OH':	'Ohio',
  'OK':	'Oklahoma',
  'ON':	'Ontario',
  'OR':	'Oregon',
  'PA':	'Pennsylvania',
  'PE':	'Prince Edward Island',
  'PR':	'Puerto Rico',
  'QC':	'Quebec',
  'RI':	'Rhode Island',
  'SC':	'South Carolina',
  'SD':	'South Dakota',
  'SK':	'Saskatchewan',
  'TN':	'Tennessee',
  'TT':	'Trust Territory',
  'TX':	'Texas',
  'UN':	'Unknown',
  'UT':	'Utah',
  'VA':	'Virginia',
  'VI':	'Virgin Islands',
  'VT':	'Vermont',
  'WA':	'Washington',
  'WI':	'Wisconsin',
  'WV':	'West Virginia',
  'WY':	'Wyoming',
  'YT':	'Yukon',
};
